import { schedulingActionTypes } from './../constants/ApiConstants';
import { loginActionTypes } from '../../logins/constants/ApiConstants';

const initialState = {
  appointments_list: [],
  loading: false,
  loadingPatientDetails: false,
  loadingSearchPatients: false,
  loadingPatientAuthDetails: false,
  loadingPatientInsurance: false,
  loadingPatientAuthorizations: false,
  loadingRecurrenceAppointments: false,
  loadingCreateAppointment: false,
  loadingAppointmentList: false,
  appointment_created: false,
  cancelledAppointment: null,
  unCancelledAppointment: null,
  master_data: [],
  patients: [],
  appointment_deleted: false,
  get_activities_data: [],
  activity_deleted: {},
  activity_added: null,
  saved_master_template: {},

  get_availability_template: [],
  availability_deleted: {},
  get_availability_template_by_id: {},
  staffsAndPatientsByLocation: null,
  onlyInActiveStaffAndPatientsByLocation:null,
  staffsAndPatientsBySingleLocation: null,
  checkValidAppointment: null,
  verifyRecurrenceAppointments: null,
  patientDetails: null,
  patientAuthorizationDetails: null,
  patientAuthorizationDetailsWithUpdateAppointment: null,
  updateSelectedSchedulerData: null,
  checkValidAppointment_inUndoCancel: null,
  patientInsuranceList: [],
  patientAuthorizationsList: null,
  updateAppointmentStatusDetail: null,
  clinicalRoomAvailablityDetails: null,
  //clinicalRoomAvailablityDetailsWithUpdateAppointment: null,
  auditLogForSessionData: [],
  patientInsuranceDetails:null,
  
  isShowInActiveStaffActive: false,
  isShowInActivePatientsActive:false,
  patientInsuranceListByDOS: null,
  clientAvailability: null,
  checkValidAppointmentPatient: null,
  previousLocation:null
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  //case schedulingActionTypes.save_appointment.REQUEST:
  case schedulingActionTypes.get_masterdata.REQUEST:
  case schedulingActionTypes.delete_appointment.REQUEST:
  case schedulingActionTypes.get_activities.REQUEST:
  case schedulingActionTypes.delete_activity.REQUEST:
  case schedulingActionTypes.save_master_template.REQUEST:
  case schedulingActionTypes.get_availability_template.REQUEST:
  case schedulingActionTypes.delete_availability_template.REQUEST:
    return {
      ...state,
      master_data: state.master_data,
      loading: true,
    };
  case schedulingActionTypes.get_appointments.REQUEST:
    return {
      ...state,
      master_data: state.master_data,
      appointments_list: [],
      loadingAppointmentList: true,
    };
  case schedulingActionTypes.save_activity.REQUEST:
    return {
      ...state,
      loading: true,
      saving: true,
    };

  case schedulingActionTypes.get_user_locations.SUCCESS:
    return {
      ...state,
      loading: false,
      user_locations: payload,
    };
  case schedulingActionTypes.get_appointments.SUCCESS:
    return {
      ...state,
      loadingAppointmentList: false,
      appointments_list: payload,
      appointment_created: false,
      appointment_deleted: false,
    };
  case schedulingActionTypes.get_appointment_by_id.REQUEST:
    return {
      ...state,
      master_data: state.master_data,
      loading: true,
      appointment: null,
    };
  case schedulingActionTypes.get_appointment_by_id.SUCCESS:
    return {
      ...state,
      loading: false,
      appointment: payload,
    };
  case schedulingActionTypes.cancel_appointment.REQUEST:
    return {
      ...state,
      loading: true,
      cancelledAppointment: null,
    };
  case schedulingActionTypes.cancel_appointment.SUCCESS:
    return {
      ...state,
      loading: false,
      cancelledAppointment: payload,
    };
  case schedulingActionTypes.undoCancelled_appointment.REQUEST:
    return {
      ...state,
      loading: true,
      unCancelledAppointment: null,
    };
  case schedulingActionTypes.undoCancelled_appointment.SUCCESS:
    return {
      ...state,
      loading: false,
      unCancelledAppointment: payload,
    };
  case schedulingActionTypes.get_masterdata.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };
  case schedulingActionTypes.check_isValidAppointment.REQUEST:
    return {
      ...state,
      loadingCheckAvailablity: true,
      checkValidAppointment: null,
    };
  case schedulingActionTypes.check_isValidAppointment.SUCCESS:
  case schedulingActionTypes.check_isValidAppointment.FAILURE:
    return {
      ...state,
      loadingCheckAvailablity: false,
      checkValidAppointment: payload,
    };
  case schedulingActionTypes.check_isValidAppointment_patient.REQUEST:
    return {
      ...state,
      loadingCheckAvailablity: true,
      checkValidAppointmentPatient: null,
    };
  case schedulingActionTypes.check_isValidAppointment_patient.SUCCESS:
  case schedulingActionTypes.check_isValidAppointment_patient.FAILURE:
    return {
      ...state,
      loadingCheckAvailablity: false,
      checkValidAppointmentPatient: payload,
    };
  case schedulingActionTypes.check_isValidAppointment_inUndoCancel.REQUEST:
    return {
      ...state,
      loading: true,
      checkValidAppointment_inUndoCancel: null,
    };
  case schedulingActionTypes.check_isValidAppointment_inUndoCancel.SUCCESS:
    return {
      ...state,
      loading: false,
      checkValidAppointment_inUndoCancel: payload,
    };
  case schedulingActionTypes.verify_Recurrence_appointments.REQUEST:
    return {
      ...state,
      loadingRecurrenceAppointments: true,
      verifyRecurrenceAppointments: null,
    };
  case schedulingActionTypes.verify_Recurrence_appointments.SUCCESS:
    return {
      ...state,
      loadingRecurrenceAppointments: false,
      verifyRecurrenceAppointments: payload,
    };
  case schedulingActionTypes.save_appointment.REQUEST:    
    return {
      ...state,
      loadingCreateAppointment: true,
      appointment_created: false,
    };
  case schedulingActionTypes.save_appointment.SUCCESS:
    return {
      ...state,
      loadingCreateAppointment: false,
      appointment_created: true,
    };
  case schedulingActionTypes.search_patient.REQUEST:
    return {
      ...state,
      loadingSearchPatients: true,
    };
  case schedulingActionTypes.search_patient.SUCCESS:
    return {
      ...state,
      loadingSearchPatients: false,
      patients: payload,
    };
  case schedulingActionTypes.delete_appointment.SUCCESS:
    return {
      ...state,
      loading: false,
      appointment_deleted: true,
    };
  case schedulingActionTypes.get_activities.SUCCESS:
    return {
      ...state,
      loading: false,
      get_activities_data: payload,
    };
  case schedulingActionTypes.delete_activity.SUCCESS:
    return {
      ...state,
      activity_deleted: payload,
      loading: false,
    };
  // case schedulingActionTypes.delete_activity.FAILURE:
  //   return {
  //     ...state,
  //     loading: false,
  //   };
  case schedulingActionTypes.save_activity.SUCCESS:
    return {
      ...state,
      loading: false,
      activity_added: payload.data,
      saving: false,
    };
  case schedulingActionTypes.save_master_template.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_master_template: payload,
    };
  case schedulingActionTypes.get_availability_template.SUCCESS:
    return {
      ...state,
      loading: false,
      get_availability_template: payload,
      get_availability_template_by_id: {},
    };
  case schedulingActionTypes.delete_availability_template.SUCCESS:
    return {
      ...state,
      loading: false,
      availability_deleted: payload,
    };
  case schedulingActionTypes.get_office_hours.REQUEST:
    return {
      ...state,
      loading: true,
      office_hours: null,
    };
  case schedulingActionTypes.get_office_hours.SUCCESS:
    return {
      ...state,
      loading: false,
      office_hours: payload,
    };
  case schedulingActionTypes.get_master_tags.REQUEST:
    return {
      ...state,
      master_data: state.master_data,
      loading: true,
      masterTags: null,
    };
  case schedulingActionTypes.get_master_tags.SUCCESS:
    return {
      ...state,
      loading: false,
      masterTags: payload,
    };
  case schedulingActionTypes.get_staffs_availability.REQUEST:
    return {
      ...state,
      master_data: state.master_data,
      loading: true,
      staffsAvailibility: null,
    };
  case schedulingActionTypes.get_staffs_availability.SUCCESS:
    return {
      ...state,
      loading: false,
      staffsAvailibility: payload,
    };
  case schedulingActionTypes.get_clients_availability.REQUEST:
    return {
      ...state,
      master_data: state.master_data,
      loading: true,
      clientAvailability: null,
    };
  case schedulingActionTypes.get_clients_availability.SUCCESS:
    return {
      ...state,
      loading: false,
      clientAvailability: payload,
    };
  case schedulingActionTypes.get_staff_and_patient_bylocation.REQUEST:
    return {
      ...state,
      loading: true,
      staffsAndPatientsByLocation: null,
    };
  case schedulingActionTypes.get_staff_and_patient_bylocation.SUCCESS:
    return {
      ...state,
      loading: false,
      staffsAndPatientsByLocation: payload,
    };
  case schedulingActionTypes.get_staff_and_patient_bySingleLocation.REQUEST:
    return {
      ...state,
      loadingSearchStaffAndPatient: true,
      staffsAndPatientsBySingleLocation: null,
    };
  case schedulingActionTypes.get_staff_and_patient_bySingleLocation.SUCCESS:
    return {
      ...state,
      loadingSearchStaffAndPatient: false,
      staffsAndPatientsBySingleLocation: payload,
    };
  case schedulingActionTypes.get_patient_details.REQUEST:
    return {
      ...state,
      loadingPatientDetails: true,
      patientDetails: null,
    };
  case schedulingActionTypes.get_patient_details.SUCCESS:
    return {
      ...state,
      loadingPatientDetails: false,
      patientDetails: payload,
    };
  case schedulingActionTypes.get_patient_authorization_details.REQUEST:
    return {
      ...state,
      loadingPatientAuthDetails: true,
      patientAuthorizationDetails: null,
    };
  case schedulingActionTypes.get_patient_authorization_details.SUCCESS:
  case schedulingActionTypes.get_patient_authorization_details.FAILURE:
    return {
      ...state,
      loadingPatientAuthDetails: false,
      patientAuthorizationDetails: payload,
    };
  case schedulingActionTypes. get_patient_insurance_details.REQUEST:
    return {
      ...state,
      loadingPatientAuthDetails: true,
      patientInsuranceDetails: null,
    };
  case schedulingActionTypes. get_patient_insurance_details.SUCCESS:
  case schedulingActionTypes. get_patient_insurance_details.FAILURE:
    return {
      ...state,
      loadingPatientAuthDetails: false,
      patientInsuranceDetails: payload,
    };
  case schedulingActionTypes.get_patient_authorization_details_withUpdateAppointment.REQUEST:
    return {
      ...state,
      loading: true,
      patientAuthorizationDetailsWithUpdateAppointment: null,
    };
  case schedulingActionTypes.get_patient_authorization_details_withUpdateAppointment.SUCCESS:
  case schedulingActionTypes.get_patient_authorization_details_withUpdateAppointment.FAILURE:
    return {
      ...state,
      loading: false,
      patientAuthorizationDetailsWithUpdateAppointment: payload,
    };
  case schedulingActionTypes.update_selectedSchedulerData.SUCCESS:
    return {
      ...initialState,
      updateSelectedSchedulerData: payload,
    };
  case schedulingActionTypes.get_patient_insurance_byid.REQUEST:
    return {
      ...state,
      loadingPatientInsurance: true,
      patientInsuranceList: null,
    };
    case schedulingActionTypes.get_patient_insurance_byid.FAILURE:
      return {
        ...state,
        loadingPatientInsurance: false,
        
      };
  case schedulingActionTypes.get_patient_insurance_byid.SUCCESS:
    return {
      ...state,
      loadingPatientInsurance: false,
      patientInsuranceList: payload,
    };
  case schedulingActionTypes.get_patient_insurance_bypatientidanddos.REQUEST:
    return {
      ...state,
      loadingPatientInsurance: true,
      patientInsuranceListByDOS: null,
    };
  case schedulingActionTypes.get_patient_insurance_bypatientidanddos.SUCCESS:
    return {
      ...state,
      loadingPatientInsurance: false,
      patientInsuranceListByDOS: payload,
    };
  case schedulingActionTypes.get_patientAuthorizationsList.REQUEST:
    return {
      ...state,
      loadingPatientAuthorizations: true,
      patientAuthorizationsList: null,
    };
  case schedulingActionTypes.get_patientAuthorizationsList.SUCCESS:
    return {
      ...state,
      loadingPatientAuthorizations: false,
      patientAuthorizationsList: payload,
    };
  case schedulingActionTypes.update_patientAppointmentStatus.REQUEST:
    return {
      ...state,
      loading: true,
      updateAppointmentStatusDetail: null,
    };
  case schedulingActionTypes.update_patientAppointmentStatus.SUCCESS:
    return {
      ...state,
      loading: false,
      updateAppointmentStatusDetail: payload,
    };
  case loginActionTypes.post_login.SUCCESS:
    return {
      ...initialState,
    };
  case schedulingActionTypes.update_encounterAndGenerateClaim.REQUEST:
    return {
      ...state,
      loading: true      
    };
  case schedulingActionTypes.update_encounterAndGenerateClaim.SUCCESS:
    return {
      ...state,
      loading: false
    };    
  case schedulingActionTypes.update_sendAppointmentNotification.REQUEST:
    return {
      ...state,
      loading: true      
    };
  case schedulingActionTypes.update_sendAppointmentNotification.SUCCESS:
    return {
      ...state,
      loading: false
    };    
  case schedulingActionTypes.get_patient_clinical_room_availablity.REQUEST:
    return {
      ...state,
      loadingPatientAuthDetails: true,
      clinicalRoomAvailablityDetails: null,
    };
  case schedulingActionTypes.get_patient_clinical_room_availablity.SUCCESS:
  case schedulingActionTypes.get_patient_clinical_room_availablity.FAILURE:
    return {
      ...state,
      loadingPatientAuthDetails: false,
      clinicalRoomAvailablityDetails: payload,
    };
  // case schedulingActionTypes.get_patient_clinical_room_availablity_withUpdateAppointment.REQUEST:
  //   return {
  //     ...state,
  //     loading: true,
  //     clinicalRoomAvailablityDetailsWithUpdateAppointment: null,
  //   };
  // case schedulingActionTypes.get_patient_clinical_room_availablity_withUpdateAppointment.SUCCESS:
  // case schedulingActionTypes.get_patient_clinical_room_availablity_withUpdateAppointment.FAILURE:
  //   return {
  //     ...state,
  //     loading: false,
  //     clinicalRoomAvailablityDetailsWithUpdateAppointment: payload,
  //   };
  case schedulingActionTypes.get_AuditLogsForSession.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case schedulingActionTypes.get_AuditLogsForSession.SUCCESS:
    return {
      ...state,
      auditLogForSessionData: payload,
      loading: false,
    };
  case schedulingActionTypes.setIsShowInActiveFlages.SUCCESS:
    return {
      ...state,
      isShowInActiveStaffActive: payload.isShowInActiveStaffActive,
      isShowInActivePatientsActive: payload.isShowInActivePatientsActive
    };

    ///////////////
  case schedulingActionTypes.getInActiveStaffAndPatientByLocation.REQUEST:
    return {
      ...state,
      loading: true,
      staffsAndPatientsByLocation: null,
    };
  case schedulingActionTypes.getInActiveStaffAndPatientByLocation.SUCCESS:
    return {
      ...state,
      loading: false,
      staffsAndPatientsByLocation: payload,
    };

  
  case schedulingActionTypes.getOnlyInActiveStaffAndPatientsByLocation.REQUEST:
    return {
      ...state,
      loading:true,
      onlyInActiveStaffAndPatientsByLocation:null
    };
  case schedulingActionTypes.getOnlyInActiveStaffAndPatientsByLocation.SUCCESS:
    return {
      ...state,
      loading:false,
      onlyInActiveStaffAndPatientsByLocation:payload
    };

  case schedulingActionTypes.get_previous_location.SUCCESS:
  return {
    ...state,
    previousLocation: payload
  }  
    ////////////////////
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/scheduling/reducers/SchedulingReducer.js